<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_DimensionsEntry')"
    width="1030px"
    top="2vh"
    append-to-body
    :close-on-click-modal="false"
    :destroy-on-close="true"
    class="main-content"
  >
    <div style="width: 100%;">
      <div class="form-row grid-list">
        <el-form
          label-width="100px"
          label-position="left"
        >
          <div style="display: flex">
            <span style="font-size: 17px">{{ $t('Warehouse.CargoDetails') }}</span>
            <el-form-item class="auto-width">
              <div v-show="!openImperial" style="display: flex;text-align: left" class="title-row">
                <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:200px;text-align: right;">{{ $t('CargoMsg.Cargo_NetGrossWeight') }}(KG)：<span style="color: blue">{{ form.weightSum }}</span>({{ $t('CargoMsg.Cargo_GrossWeight3') }}: <span style="color: blue">{{ form.grossWeightSum }})</span></div>
                <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:130px;text-align: right;">{{ $t('SeaExport.ChargedWeight') }}(KG): <span style="color: blue">{{ form.chargedWeightSum }}</span> </div>
                <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:130px;text-align: right;">{{ $t('SeaExport.Quantity') }}: <span style="color: blue">{{ form.quantitySum }}</span></div>
                <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:130px;text-align: right;">{{ $t('SeaExport.Cubage') }}: <span style="color: blue">{{ form.cubageSum }}</span></div>
              </div>
              <div v-show="openImperial" style="display: flex;text-align: left" class="title-row">
                <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:200px;text-align: right;">{{ $t('CargoMsg.Cargo_NetGrossWeight') }}(LB)：<span style="color: blue">{{ form.weightSumImperial }}</span>({{ $t('CargoMsg.Cargo_GrossWeight3') }}: <span style="color: blue">{{ form.grossWeightSumImperial }})</span></div>
                <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:130px;text-align: right;">{{ $t('SeaExport.ChargedWeight') }}(LB): <span style="color: blue">{{ form.chargedWeightSumImperial }}</span> </div>
                <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:130px;text-align: right;">{{ $t('SeaExport.Quantity') }}: <span style="color: blue">{{ form.quantitySum }}</span></div>
                <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:130px;text-align: right;">{{ $t('SeaExport.Cubage') }}(CFT): <span style="color: blue">{{ form.cubAgeSumImperial }}</span></div>
              </div>
            </el-form-item>
          </div>
          <cargo-ag-grid
            ref="goodsTable"
            config-module="9300012"
            :grid-options="detailList.goodGridOptions"
            :column-defs="goodsColumn"
            :row-data="form.warehouseInDetailList || []"
            style="height: 200px;padding-top: 5px"
            @gridReady="params=>{detailList.gridApi=params.api}"
          />
        </el-form>
      </div>
      <div style="padding-top: 5px">
        <el-form
          label-width="100px"
          label-position="right"
        >
          <div style="display: flex">
            <el-form-item :label="$t('CargoMsg.Cargo_PackingCondition')">
              <el-select :value="form.packingCondition" filterable clearable @change="packingConditionHandler">
                <el-option
                  v-for="(item,index) in PACKING_CONDITION_LIST"
                  :key="index"
                  :label="$store.getters.language === 'zh' ? item.chineseName : item.englishName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_SpecialHandling')">
              <el-select :value="form.specialHandling" filterable clearable @change="specialHandlingHandler">
                <el-option
                  v-for="(item,index) in SPECIAL_HANDLING_LIST"
                  :key="index"
                  :label="$store.getters.language === 'zh' ? item.chineseName : item.englishName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
          </div>
        </el-form>

      </div>
      <div style="height: 50%; padding-top: 5px; border: 2px solid transparent;">
        <tab-warehousing-charge ref="tabCharges" :warehouse-in-uuid="uuid" :action="'edit'" :show-ar="false" />
      </div>
    </div>
    <div slot="footer" style="text-align: right">
      <el-button type="primary" @click="saveHandler(false)">{{ $t('SeaExport.Save') }}</el-button>
      <el-button type="primary" @click="saveDoneHandler">{{ $t('CargoMsg.Cargo_SaveDone') }}</el-button>
      <el-button type="default" @click="onCancel">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
    </div>

    <!-- 选择尺寸 -->
    <dimensions-dialog
      v-if="dimensionsDialog.visible"
      :visible.sync="dimensionsDialog.visible"
      :uuid="dimensionsDialog.uuid"
      :single-weight="dimensionsDialog.singleWeight"
      :dimension="dimensionsDialog.dimension"
      :open-imperial="openImperial"
      @sizeData="sizeDataHandler"
      @close="dimensionsDialog.visible = false"
    />
  </el-dialog>
</template>

<script>
import { DocumentManage } from '@/utils/commonUtil'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index.vue'
import * as NumberUtils from '@/utils/NumberUtils'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor/index.vue'
import CargoAgGridDimensionEditor from '@/components/Cargo/Common/CargoAgGridDimensionEditor/index.vue'
import { getCacheListByKey, syncSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import tabCharges from '@/components/Cargo/Job/booking/tabs/tabCharges.vue'
import TabWarehousingCharge from '@/components/Cargo/FrontEndWarehouse/components/warehousing/tabWarehousingCharge.vue'
import { detail, saveFunc } from '@/api/warehouseIn/warehouseIn'
import { getLoading } from '@/utils/utilBaseElement'
import DimensionsDialog from '@/components/Cargo/FrontEndWarehouse/components/warehouseHome/dimensionsDialog.vue'
import { TabError } from '@/utils/class/TabError'
import { WarehouseInDetail } from '@/class/model/booking/WarehouseInDetail'
import { getUuid } from '@/utils'
import { cache, cacheName } from '@/utils/cacheManager'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import * as FbaJobConstants from '@/class/cargo/model/parameters/FbaJobConstants'
import {
  LOCATION_STATE_LIST,
  PACKING_CONDITION_LIST,
  SPECIAL_HANDLING_LIST
} from '@/class/cargo/model/parameters/SystemConstants'
import * as BillingNativeUtils from '@/class/cargo/model/utils/BillingNativeUtils'

export default {
  name: 'DimensionsWindow',
  components: { DimensionsDialog, TabWarehousingCharge, tabCharges },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    uuid: {
      type: String,
      default: ''
    },
    openImperial: {
      type: Boolean,
      default: () => false
    },
    jobKey: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      PACKING_CONDITION_LIST,
      SPECIAL_HANDLING_LIST,
      documentManage: new DocumentManage(),
      addKey: 'dimensions_',
      isEditing: true,
      airportCargoTerminalDate: [], // 仓库uuid 和 波特率配置uuid 临时字段
      cWeightIsCeil: 0,
      chargeDialog: {
        context: {
          modifiedData: {}
        },
        action: 'edit'
      },
      form: {
        uuid: '',
        jobKey: '',
        jobNo: '',
        serialNumber: '',
        frontEndWarehouse: true,
        warehouseNo: '',
        carrierName: '',
        flightAndTime: '',
        vessel: '',
        portOfLoading: '',
        licensePlate: '',
        packingCondition: 0,
        specialHandling: 0,
        customerName: '',
        brokenNum: 0,
        portOfDestination: '',
        warehouseInDateTo: '',
        warehouse: '',
        airportCargoTerminalUuid: '',
        warehouseOp: 0,
        etdString: '',
        hbl: '',
        mbl: '',
        destinationPortEnglish: '',
        loadingPortEnglish: '',
        voyageFlight: '',
        state: 0,
        createdBy: 0,
        dateCreated: 0,
        branchId: this.$store.getters.currentOfficeId,
        warehouseInDate: null,
        location: '',
        palletSum: 0,
        quantitySum: 0,
        weightSum: 0.00,
        weightSumImperial: 0.00,
        chargedWeightSum: 0.00,
        chargedWeightSumImperial: 0.00,
        cubageSum: 0.000,
        cubAgeSumImperial: 0.000,
        grossWeightSum: 0.000,
        grossWeightSumImperial: 0.000,
        quantityContract: 0,
        weightContract: 0.00,
        cubageContract: 0.000,
        version: null,
        receiptNo: '',
        deliveryCmp: '',
        truckNo: '',
        vehicleType: '',
        driver: '',
        driverTel: '',
        remarks: '',
        broken: false,
        receiveDc: false,
        brokenQuantity: 0,
        sealCargo: 0,
        brokenDes: '',
        comments: '',
        warehouseOutDate: '',
        estimatedDeliveryTime: '',
        estimatedWarehousingTime: '',
        outType: '',
        label: '',
        sealWeight: '',
        lob: this.lob,
        referenceNo: '',
        jobMark: '',
        ownWarehouse: false,
        takePhotos: false,
        documentsAttached: false,
        otherWarehouseNotes: '',
        warehouseStatus: 0, // 入库状态
        businessDocumentVOList: [],
        operationRequirementVOList: [],
        warehouseInDetailList: []
      },
      dimensionsDialog: {
        dimension: '',
        uuid: '',
        singleWeight: 0,
        visible: false
      },
      detailList: {
        gridApi: null,
        goodGridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          suppressRowClickSelection: false,
          selectedRowIndex: -1,
          singleClickEdit: true,
          onCellFocused: event => {
            this.detailList.goodGridOptions.selectedRowIndex = event.rowIndex
          },
          // 添加编辑组件
          frameworkComponents: {
            CargoAgGridCommonInputEditor,
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridDimensionEditor
          }
        }
      }
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        }
      }
    },
    detailListSelectedRow() {
      return this.form.warehouseInDetailList[this.detailList.goodGridOptions.selectedRowIndex]
    },
    goodsColumn() {
      let list = []
      if (this.openImperial) {
        list = [{
          headerName: this.$t('CargoMsg.Cargo_ScaleWeight') + '(LB)',
          field: 'weighbridgeWeightImperial',
          colId: 'weighbridgeWeightImperial',
          width: 120,
          // 是否开启编辑
          editable: () => false,
          // 单元格绑定编辑组件
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 编辑组件入参
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 2,
              max: 999999999,
              min: 0,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          },
          valueFormatter: params => {
            return this.$numeral(NumberUtils.roundHalfUp(params.value, 2)).format('0,0.00') || 0.000
          },
          onCellValueChanged: (params) => this.weightChange(params, true)
        }, {
          headerName: this.$t('CargoMsg.Cargo_TareWeight') + '(LB)',
          field: 'tareWeightImperial',
          colId: 'tareWeightImperial',
          width: 120,
          // 是否开启编辑
          editable: () => false,
          // 单元格绑定编辑组件
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 编辑组件入参
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 2,
              max: 999999999,
              min: 0,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          },
          valueFormatter: params => {
            return this.$numeral(NumberUtils.roundHalfUp(params.value, 2)).format('0,0.00') || 0.000
          },
          onCellValueChanged: (params) => this.weightChange(params, true)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_GrossWeight2') + '(LB)',
          field: 'grossWeightImperial',
          colId: 'grossWeightImperial',
          width: 120,
          // 是否开启编辑
          editable: () => false,
          // 单元格绑定编辑组件
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 编辑组件入参
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 2,
              max: 999999999,
              min: 0,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          },
          valueFormatter: params => {
            return this.$numeral(NumberUtils.roundHalfUp(params.value, 2)).format('0,0.00') || 0.000
          },
          onCellValueChanged: (params) => this.weightChange(params, true)
        }, {
          headerName: this.$t('CargoMsg.Cargo_NetGrossWeight') + '(LB)',
          field: 'weightImperial',
          colId: 'weightImperial',
          width: 120,
          // 是否开启编辑
          editable: () => false,
          valueFormatter: params => {
            return this.$numeral(NumberUtils.roundHalfUp(params.value, 2)).format('0,0.00') || 0.000
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_measurements2'),
          field: 'dimensionImperial',
          colId: 'dimensionImperial',
          maxWidth: 500,
          minWidth: 300,
          editable: () => false,
          cellRenderer: params => {
            const onDimension = this.documentManage.getPath('onDimension')
            let value = params.value
            if (value && value.length > 30) {
              value = value.substring(0, 29) + '...'
            }
            return `<div><a onclick="${onDimension}('${params.data.uuid}')" style="color:#1F75D5;font-size:16px;">${value}✎</a></div>`
          }
        },
        {
          headerName: this.$t('SeaExport.SingleWeight') + '(LB)',
          field: 'singleWeightImperial',
          colId: 'singleWeightImperial',
          width: 120,
          valueFormatter: params => {
            return this.$numeral(NumberUtils.roundHalfUp(params.value, 2)).format('0,0.00') || 0.000
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Cubage') + '(CFT)',
          field: 'cubAgeImperial',
          colId: 'cubAgeImperial',
          width: 150,
          // 是否开启编辑
          editable: () => false,
          // 单元格绑定编辑组件
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 编辑组件入参
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 3,
              max: 999999999,
              min: 0,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          },
          valueFormatter: params => {
            return this.$numeral(NumberUtils.roundHalfUp(params.value, 3)).format('0,0.000') || 0.000
          },
          onCellValueChanged: (params) => {
            this.cubAgeChange(params, true)
          }
        }]
      } else {
        list = [{
          headerName: this.$t('CargoMsg.Cargo_ScaleWeight'),
          field: 'weighbridgeWeight',
          colId: 'weighbridgeWeight',
          width: 120,
          // 是否开启编辑
          editable: () => false,
          // 单元格绑定编辑组件
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 编辑组件入参
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 2,
              max: 999999999,
              min: 0,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          },
          valueFormatter: params => {
            return this.$numeral(NumberUtils.roundHalfUp(params.value, 2)).format('0,0.00') || 0.000
          },
          onCellValueChanged: (params) => this.weightChange(params, false)
        }, {
          headerName: this.$t('CargoMsg.Cargo_TareWeight'),
          field: 'tareWeight',
          colId: 'tareWeight',
          width: 120,
          // 是否开启编辑
          editable: () => false,
          // 单元格绑定编辑组件
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 编辑组件入参
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 2,
              max: 999999999,
              min: 0,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          },
          valueFormatter: params => {
            return this.$numeral(NumberUtils.roundHalfUp(params.value, 2)).format('0,0.00') || 0.000
          },
          onCellValueChanged: (params) => this.weightChange(params, false)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_GrossWeight2'),
          field: 'grossWeight',
          colId: 'grossWeight',
          width: 120,
          // 是否开启编辑
          editable: () => false,
          // 单元格绑定编辑组件
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 编辑组件入参
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 2,
              max: 999999999,
              min: 0,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          },
          valueFormatter: params => {
            return this.$numeral(NumberUtils.roundHalfUp(params.value, 2)).format('0,0.00') || 0.000
          },
          onCellValueChanged: (params) => this.weightChange(params, false)
        }, {
          headerName: this.$t('CargoMsg.Cargo_NetGrossWeight') + 'KGS',
          field: 'weight',
          colId: 'weight',
          width: 120,
          // 是否开启编辑
          editable: () => false,
          valueFormatter: params => {
            return this.$numeral(NumberUtils.roundHalfUp(params.value, 2)).format('0,0.00') || 0.000
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_measurements'),
          field: 'dimension',
          colId: 'dimension',
          maxWidth: 500,
          minWidth: 300,
          editable: () => false,
          cellRenderer: params => {
            const onDimension = this.documentManage.getPath('onDimension')
            let value = params.value
            if (value && value.length > 30) {
              value = value.substring(0, 29) + '...'
            }
            return `<div><a onclick="${onDimension}('${params.data.uuid}')" style="color:#1F75D5;font-size:16px;">${value}✎</a></div>`
          }
        },
        {
          headerName: this.$t('SeaExport.SingleWeight') + 'KGS',
          field: 'singleWeight',
          colId: 'singleWeight',
          width: 120,
          valueFormatter: params => {
            return this.$numeral(NumberUtils.roundHalfUp(params.value, 2)).format('0,0.00') || 0.000
          }
        }, {
          headerName: this.$t('SeaExport.Cubage2'),
          field: 'cubage',
          colId: 'cubage',
          width: 150,
          // 是否开启编辑
          editable: () => false,
          // 单元格绑定编辑组件
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 编辑组件入参
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 3,
              max: 999999999,
              min: 0,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          },
          valueFormatter: params => {
            return this.$numeral(NumberUtils.roundHalfUp(params.value, 3)).format('0,0.000') || 0.000
          },
          onCellValueChanged: (params) => {
            this.cubAgeChange(params, false)
          }
        }]
      }

      list.push({
        headerName: this.$t('CargoMsg.Cargo_OurPallet'),
        field: 'palletNo',
        colId: 'palletNo',
        width: 150,
        editable: () => false,
        cellEditor: 'CargoAgGridAdvanceSelectEditor',
        cellEditorParams: (params) => {
          // 未删除的 循环托盘或者 回收托盘且未被占用
          const staticOptions = this.getPalletConfigurations(params.value || '')
          return {
            selectProps: {
              tagValue: 'uuid',
              tagName: 'palletCode',
              staticOptions,
              filterable: true
            }
          }
        },
        valueFormatter: params => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_PalletConfiguration, 'uuid', params.value, 'palletCode')
        },
        onCellValueChanged: (params) => this.palletNoChange(params)
      }, {
        headerName: this.$t('SeaExport.PackageType'),
        field: 'packing',
        colId: 'packing',
        width: 150,
        editable: () => this.isEditing,
        cellEditor: 'CargoAgGridAdvanceSelectEditor',
        cellEditorParams: {
          selectProps: {
            tagName: 'chineseName',
            selectType: TYPE_NAMES.basic_data_Packing,
            callbackParams: { key: 'code' },
            callbackMethodType: 'value',
            filterable: true
          }
        },
        valueFormatter: params => {
          return ColumnUtils.packingCodeLabelFun(params.value)
        }
      }, {
        headerName: this.$t('CargoMsg.Cargo_ItemsNBR'),
        field: 'quantity',
        colId: 'quantity',
        width: 120,
        // 是否开启编辑
        editable: false,
        // 单元格绑定编辑组件
        cellEditor: 'CargoAgGridCommonInputEditor',
        // 编辑组件入参
        cellEditorParams: {
          isNumber: true,
          inputProps: {
            precision: 0,
            max: 999999999,
            min: 0,
            controlsPosition: 'right',
            style: 'width: 100%'
          }
        }
      }, {
        headerName: this.$t('CargoMsg.Cargo_Remarks'), field: 'remarks',
        colId: 'remarks',
        minWidth: 200,
        // 是否开启编辑
        editable: () => false,
        // 单元格绑定编辑组件
        cellEditor: 'CargoAgGridCommonInputEditor',
        // 编辑组件入参
        cellEditorParams: {
          isNumber: false
        }
      }, {
        headerName: this.$t('CargoMsg.Cargo_PalletNumber'),
        field: 'palletNumber',
        colId: 'palletNumber',
        width: 120
      }, {
        headerName: this.$t('CargoMsg.Cargo_Location2'),
        field: 'storageLocation',
        colId: 'storageLocation',
        width: 150,
        editable: () => this.isEditing,
        cellEditor: 'CargoAgGridAdvanceSelectEditor',
        cellEditorParams: (params) => {
          const staticOptions = this.getLocationConfigurations(params.value || '')
          return {
            selectProps: {
              tagValue: 'uuid',
              tagName: 'name',
              staticOptions,
              filterable: true,
              filterTagNames: ['name']
            }
          }
        },
        valueFormatter: params => {
          return ColumnUtils.storageLocationColumnUtils(params.value)
        }
      })
      return list
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('onDimension', function(value) {
      context.onDimension(value)
    })
  },
  async created() {
    await this.init()
  },
  methods: {
    onCancel() {
      this.$emit('close')
    },
    async init() {
      await cache.load(cacheName.CONFIG)
      this.cWeightIsCeil = Number(cache.config.get('AEcWeightCeil')) // 计费重量是否取整
      await this.handleGetWarehouseInInfo()
      await this.loadCharges()
    },
    async loadCharges() {
      this.loading = getLoading()
      this.$nextTick(() => {
        this.$refs['tabCharges'].onShow(true)
        this.loading.close()
      })
    },
    async handleGetWarehouseInInfo() {
      this.loading = getLoading()
      detail({ warehouseInUuid: this.uuid, type: 'AE' })
        .then((res) => {
          this.$emit('refreshHandler')
          Object.keys(this.form).forEach((key) => {
            this.loading.close()
            if (res.data[key]) {
              this.form[key] = res.data[key]
              this.airportCargoTerminalDate = [this.form.airportCargoTerminalUuid]
              if (key === 'warehouseInDetailList' && this.form.warehouseInDetailList.length > 0) {
                for (const detail of this.form.warehouseInDetailList) {
                  if (detail.dimension) { // 拆分长宽高件数
                    const array = detail.dimension.split('*')
                    detail.sizeLength = array[0]
                    detail.sizeWidth = array[1]
                    detail.sizeHeight = array[2]
                    detail.sizeQuantity = array[3]
                  }
                }
              }
            }
          })
          this.calcSum()
        })
        .catch(() => {
          this.loading.close()
        })
      this.loading.close()
    },
    onDimension(uuid) {
      const vo = this.form.warehouseInDetailList.find(p => p.uuid === uuid)
      if (vo) {
        this.dimensionsDialog.dimension = vo.dimension
        this.dimensionsDialog.singleWeight = vo.singleWeight
      }
      this.dimensionsDialog.uuid = uuid
      this.dimensionsDialog.visible = true
    },
    palletNoChange(params) {
      if (params.data.palletNo) {
        const options = getCacheListByKey(basicCacheKeys.basic_data_PalletConfiguration).filter(p => !p.deletionFlag && p.uuid === params.data.palletNo)
        if (options) {
          params.data.tareWeight = Number(options[0].palletTareWeight)
        }
      }
      this.weightChange(params)
      this.detailList.goodGridOptions.api.refreshCells({ force: true })
    },
    // 重量改变
    weightChange(params, imperial) {
      // 净毛重 = 地磅重量 - 皮重 + 配重
      const data = params.data
      this.detailChange(data, imperial)
    },
    async detailChange(data, imperial) {
      if (imperial) {
        data.weighbridgeWeight = await JobUtils.calculateWeight(data.weighbridgeWeightImperial)
        data.tareWeight = await JobUtils.calculateWeight(data.tareWeightImperial)
        data.grossWeight = await JobUtils.calculateWeight(data.grossWeightImperial)
      }
      data.weight = NumberUtils.ToFixed2(Number(data.weighbridgeWeight || 0) - Number(data.tareWeight || 0) + Number(data.grossWeight || 0), 3)
      data.weightImperial = await JobUtils.calculateWeight(data.weight, true)
      // 单件重量 = 重量/件数
      if (data.quantity && data.weight) {
        data.singleWeight = NumberUtils.ToFixed2(Number(data.weight) / Number(data.quantity), 2)
        data.singleWeightImperial = await JobUtils.calculateWeight(data.singleWeight, true)
      } else {
        data.singleWeight = 0
      }
      if (!imperial) {
        data.weighbridgeWeightImperial = await JobUtils.calculateWeight(data.weighbridgeWeight, true)
        data.tareWeightImperial = await JobUtils.calculateWeight(data.tareWeight, true)
        data.grossWeightImperial = await JobUtils.calculateWeight(data.grossWeight, true)
      }
      await this.calcSum()
      this.detailList.goodGridOptions.api.refreshCells({ force: true })
    },
    // 体积改变
    async cubAgeChange(params, imperial) {
      const data = params.data
      if (imperial) {
        data.cubage = await JobUtils.calculateCubAge(data.cubAgeImperial)
      } else {
        data.cubAgeImperial = await JobUtils.calculateCubAge(data.cubage, true)
      }
      await this.calcSum()
      this.detailList.goodGridOptions.api.refreshCells({ force: true })
    },
    async sizeDataHandler(e) {
      if (e.dimension && e.uuid) {
        const vo = this.form.warehouseInDetailList.find(p => p.uuid === e.uuid)
        if (vo) {
          const list = e.dimension.split(';')
          // 英制单位
          if (this.openImperial) {
            vo.dimensionImperial = e.dimension
            const dimensionNew = []
            for (const d of list) {
              const value = d.split('*')
              if (value.length === 4) {
                const sizeLength = Number(value[0]) || 0
                const sizeWidth = Number(value[1]) || 0
                const sizeHeight = Number(value[2]) || 0
                const sizeQuantity = Number(value[3]) || 0
                // 计算公制单位
                const d = await JobUtils.calculateDimension(sizeLength, sizeWidth, sizeHeight, sizeQuantity)
                if (d) {
                  dimensionNew.push(d)
                }
              }
            }
            vo.dimension = dimensionNew.join(';')
            vo.cubage = this.getCubAge(vo.dimension)
            vo.cubAgeImperial = await JobUtils.calculateCubAge(vo.cubage, true)
          } else {
            vo.dimension = e.dimension
            vo.cubage = this.getCubAge(vo.dimension)
            const dimensionImperials = []
            for (const d of list) {
              const value = d.split('*')
              if (value.length === 4) {
                const sizeLength = Number(value[0]) || 0
                const sizeWidth = Number(value[1]) || 0
                const sizeHeight = Number(value[2]) || 0
                const sizeQuantity = Number(value[3]) || 0
                // 计算公制单位
                const d = await JobUtils.calculateDimension(sizeLength, sizeWidth, sizeHeight, sizeQuantity, true)
                if (d) {
                  dimensionImperials.push(d)
                }
              }
            }
            vo.dimensionImperial = dimensionImperials.join(';')
            vo.cubAgeImperial = await JobUtils.calculateCubAge(vo.cubage, true)
          }
        }
      }
      this.calcSum()
      this.detailList.goodGridOptions.api.refreshCells({ force: true })
    },
    // 计算
    async calcSum() {
      let quantitySum = 0
      let weightSum = 0
      let sum = 0
      let grossWeightSum = 0
      let weightSumImperial = 0
      let cubAgeSumImperial = 0
      let grossWeightSumImperial = 0
      for (const detail of this.form.warehouseInDetailList) {
        quantitySum += detail.quantity
        weightSum += Number(detail.weight)
        sum += this.getCubAge(detail.dimension, false)
        grossWeightSum += Number(detail.grossWeight)
        weightSumImperial += Number(detail.weightImperial)
        cubAgeSumImperial += Number(detail.cubAgeImperial)
        grossWeightSumImperial += Number(detail.grossWeightImperial)
      }
      this.form.quantitySum = quantitySum
      this.form.weightSum = weightSum
      this.form.cubageSum = NumberUtils.ToFixed2(sum / 1000 / 1000, 3) // 获取体积
      this.form.grossWeightSum = grossWeightSum
      this.form.chargedWeightSum = JobUtils.calcChargeWeight(this.form.weightSum, this.form.cubageSum, true, this.cWeightIsCeil)
      // 计费重量 = 毛重和体积重量的大者
      this.form.chargedWeightSum = Math.max(this.form.chargedWeightSum, this.form.weightSum)

      this.form.weightSumImperial = weightSumImperial
      this.form.cubAgeSumImperial = cubAgeSumImperial
      this.form.grossWeightSumImperial = grossWeightSumImperial
      this.form.chargedWeightSumImperial = await JobUtils.calculateWeight(this.form.chargedWeightSum, true)
      this.form.palletSum = this.form.warehouseInDetailList.length
    },
    getCubAge(dimension, needResult = true) {
      let sum = 0
      let cubAgeSum = 0
      if (dimension) {
        // 65*55*41*3;82*71*63*5
        const s = dimension.split(';')
        for (const d of s) {
          const r = d.split('*')
          let volume = 1
          for (const n of r) {
            volume *= n
          }
          sum += volume
        }
        if (needResult) {
          cubAgeSum = NumberUtils.ToFixed2(sum / 1000 / 1000, 3) // 获取体积
        } else {
          cubAgeSum = sum
        }
      }
      return cubAgeSum
    },
    // 加入货物
    addDetailHandler() {
      const detail = new WarehouseInDetail().fillDefaultValue().getData()
      detail.uuid = this.addKey + getUuid()
      detail.warehouseInUuid = this.form.uuid
      detail.dimension = '0*0*0*1'
      detail.sizeLength = 0
      detail.sizeWidth = 0
      detail.sizeHeight = 0
      detail.sizeQuantity = 1
      detail.quantity = 1
      detail.grossWeight = 0
      detail.weight = 0.00
      detail.cubage = 0.000
      detail.singleWeight = 0.00
      detail.dimensionImperial = '0*0*0*1'
      detail.grossWeightImperial = 0
      detail.weightImperial = 0.00
      detail.cubAgeImperial = 0.000
      detail.singleWeightImperial = 0.00
      const staticOptions = getCacheListByKey(basicCacheKeys.basic_data_LocationConfiguration).filter(p => !p.deletionFlag)
      // 只有一个库位直接带出
      if (staticOptions && staticOptions.length === 1) {
        detail.storageLocation = staticOptions[0].uuid
      }
      this.form.warehouseInDetailList.push(detail)
      this.calcSum()
    },
    // 删除货物
    delDetailHandler() {
      if (this.detailListSelectedRow) {
        const index = this.detailList.goodGridOptions.selectedRowIndex
        if (index > -1) {
          this.form.warehouseInDetailList.splice(index, 1)
        }
      } else {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
      this.calcSum()
    },
    // 拿到可用库位
    getLocationConfigurations(nowUuid) {
      let warehouseInUuid = ''
      if (this.airportCargoTerminalDate.length > 0) {
        warehouseInUuid = this.airportCargoTerminalDate[0]
      }
      // 1.根据当前选择的仓库过滤 2.库位状态未删除的。
      // 当前正在用的默认放出来
      const list = getCacheListByKey(basicCacheKeys.basic_data_LocationConfiguration).filter(p => (!p.deletionFlag &&
        p.airportCargoTerminalUuid === warehouseInUuid) || p.uuid === nowUuid)
      const newList = []
      for (const data of list) {
        const vo = {}
        vo.name = data.locationCode + '(' + ColumnUtils.showTypeLabelFunc(data.locationStatus, LOCATION_STATE_LIST) + ')'
        vo.uuid = data.uuid
        newList.push(vo)
      }
      return newList
    },
    // 拿到可用托盘
    getPalletConfigurations(nowUuid) {
      let warehouseInUuid = ''
      if (this.airportCargoTerminalDate.length > 0) {
        warehouseInUuid = this.airportCargoTerminalDate[0]
      }
      // 1.根据当前选择的仓库过滤 2.托盘状态未删除的。3.循环托盘或者 回收托盘且未被占用
      // 当前正在用的默认放出来
      return getCacheListByKey(basicCacheKeys.basic_data_PalletConfiguration).filter(p => (!p.deletionFlag &&
          (p.recycleType === 0 || (p.recycleType === 1 && p.palletStatus !== 2)) && p.airportCargoTerminalUuid === warehouseInUuid) ||
        p.uuid === nowUuid)
    },
    packingConditionHandler(e) {
      this.form.packingCondition = e
    },
    specialHandlingHandler(e) {
      this.form.specialHandling = e
    },
    async saveHandler(saveDone) {
      this.loading = getLoading()
      let getChargeSubmitData = null
      try {
        if (this.$refs['tabCharges']) {
          getChargeSubmitData = this.$refs['tabCharges'].getSubmitData()
        }
      } catch (err) {
        if (err instanceof TabError) {
          if (err.message) {
            this.$message.warning({ dangerouslyUseHTMLString: true, message: err.message })
          }
          this.loading.close()
          return
        }
        throw err
      }
      let tip = false
      // 如果仓库明细列表存在，直接修改 uuid
      if (this.form.warehouseInDetailList) {
        this.form.warehouseInDetailList.forEach(ind => {
          if (ind.uuid.includes(this.addKey)) {
            ind.uuid = ''
          }
          let quantitySum = 0
          if (ind.dimension) {
            const list = ind.dimension.split(';')
            for (const dd of list) {
              const arr = dd.split('*')
              if (!arr || arr.length !== 4) {
                continue // 长*宽*高*件数，非这个格式则不处理
              }
              quantitySum += Number(arr[3])
            }
          }
          if (ind.quantity !== quantitySum) {
            tip = true
          }
        })
      }
      if (tip) {
        this.loading.close()
        this.$confirm(this.$t('CargoMsg.Cargo_TotalPiecesMismatchContinue'), this.$t('CargoMsg.Cargo_Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          type: 'warning'
        }).then(async() => {
          this.doSave(saveDone, getChargeSubmitData)
        })
      } else {
        this.doSave(saveDone, getChargeSubmitData)
      }
    },
    doSave(saveDone, getChargeSubmitData) {
      this.loading = getLoading()
      const params = { ...this.form, ...getChargeSubmitData }
      params.check = false
      params.saveDone = saveDone
      saveFunc(params).then(resp => {
        if (resp && resp.data === FbaJobConstants.WAREHOUSE_OP_STORED) {
          this.$message.warning(this.$t('SeaExport.StoredTipFour'))
          return
        }
        syncSpecificBasicData(basicCacheKeys.basic_data_LocationConfiguration)
        syncSpecificBasicData(basicCacheKeys.basic_data_PalletConfiguration)
        this.$message.success(this.$t('Message.SavedSuccessfully'))
        this.onCancel()
      }).finally(() => this.loading.close())
    },
    // 保存并入仓完成
    saveDoneHandler() {
      const warehouseInDetailList = this.form.warehouseInDetailList
      if (!warehouseInDetailList || warehouseInDetailList.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoEligibleRecord'))
        return
      }
      for (const data of warehouseInDetailList) {
        if (!data.storageLocation) {
          this.$message.warning(this.$t('CargoMsg.Cargo_NoLocationSelected'))
          return
        }
      }
      this.saveHandler(true)
    }
  }
}
</script>

<style scoped>

</style>
